import { render, staticRenderFns } from "./SingleSignOn438.vue?vue&type=template&id=2ccce87b"
import script from "./SingleSignOn438.vue?vue&type=script&lang=js"
export * from "./SingleSignOn438.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports